import { useContext, useEffect, useState } from 'react'

import RMAContext from '@/returns/pages/TransactionRMAPage/context/RMAContext'

const useRegion = () => {
  const { rmaInfo, setRmaInfo } = useContext(RMAContext)
  const selectedCountry = rmaInfo?.orderInfo?.shipping_address?.country
  const [selectedProvince, setSelectedProvince] = useState(null)
  const [showRegionDrawer, setShowRegionDrawer] = useState(false)

  useEffect(() => {
    if (rmaInfo?.orderInfo?.shipping_address?.province?.id) {
      setSelectedProvince(rmaInfo?.orderInfo?.shipping_address?.province?.id)
    }
  }, [rmaInfo?.orderInfo?.shipping_address?.province?.id])

  useEffect(() => {
    if (!rmaInfo?.orderInfo?.shipping_address?.province?.id && rmaInfo?.allowed_region?.provinces?.length > 0) {
      setShowRegionDrawer(true)
    }
  }, [rmaInfo?.orderInfo?.shipping_address?.province?.id, rmaInfo?.allowed_region?.provinces?.length])

  const getSelectedProvince = () => {
    if (rmaInfo?.allowed_region?.provinces?.length > 0) {
      return `${rmaInfo?.allowed_region?.provinces?.find(p => p.id === selectedProvince)?.name || ''},`
    }
    return ''
  }

  const openRegionDrawer = () => {
    setShowRegionDrawer(true)
  }

  const closeRegionDrawer = () => {
    setShowRegionDrawer(false)
  }

  const onChangeRegion = regionId => {
    const newRegion = rmaInfo?.allowed_region?.provinces.find(p => p.id === regionId)
    setRmaInfo(rmaInfo => ({
      ...rmaInfo,
      orderInfo: {
        ...rmaInfo.orderInfo,
        shipping_address: {
          ...rmaInfo.orderInfo.shipping_address,
          province: newRegion,
        },
      },
    }))

    setShowRegionDrawer(false)
  }

  return {
    selectedProvince,
    setSelectedProvince,
    selectedCountry,
    getSelectedProvince,
    openRegionDrawer,
    closeRegionDrawer,
    showRegionDrawer,
    provinces: rmaInfo?.allowed_region?.provinces?.map(p => ({ value: p.id, label: p.name })) || [],
    onChangeRegion,
    disabledChangeRegion: !(rmaInfo?.allowed_region?.provinces?.length > 0),
  }
}

export default useRegion
